const styles = theme => ({
  root: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    minHeight: 60,
    "&> button": {
      flex: 1,
      borderRadius: 0,
      color: theme.palette.secondary.light,
      backgroundColor: theme.palette.primary.main,
      textTransform: "uppercase",
      fontFamily: "'Poppins', 'sans-serif'",
      fontWeight: "700",
      "@supports (padding-bottom: constant(safe-area-inset-bottom))": {
        "--safe-area-inset-bottom": "constant(safe-area-inset-bottom)",
        paddingBottom: "var(--safe-area-inset-bottom)"
      },
      "@supports (padding-bottom: env(safe-area-inset-bottom))": {
        "--safe-area-inset-bottom": "env(safe-area-inset-bottom)",
        paddingBottom: "var(--safe-area-inset-bottom)"
      },
      "&:hover": {
        background: theme.palette.primary.main
      },
      "&:nth-of-type(1)": {
        display: "flex",
        flexDirection: "column",
        borderRadius: 0,
        color: theme.palette.primary.light,
        backgroundColor: theme.palette.secondary.light,
        "&> span": {
          flexDirection: "column",
          alignItems: "flex-start",
          "&> span": {
            fontSize: 10,
            textTransform: "none",
            fontFamily: "'Open sans', 'sans-serif'",
            fontWeight: "400"
          }
        }
      }
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/SplitBottomNav/styles.js